// extracted by mini-css-extract-plugin
module.exports = {"heading":"PopupHeader_heading__rf12W","close":"PopupHeader_close__2z5d2"};